import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/esm/inheritsLoose";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/esm/objectWithoutPropertiesLoose";

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import FarceActions from 'farce/Actions';
import React from 'react';
import { Provider } from 'react-redux';
import createConnectedRouter from './createConnectedRouter';
import createFarceStore from './createFarceStore';
export default function createFarceRouter(_ref) {
  var store = _ref.store,
      historyProtocol = _ref.historyProtocol,
      historyMiddlewares = _ref.historyMiddlewares,
      historyOptions = _ref.historyOptions,
      routeConfig = _ref.routeConfig,
      options = _objectWithoutPropertiesLoose(_ref, ["store", "historyProtocol", "historyMiddlewares", "historyOptions", "routeConfig"]);

  var ConnectedRouter = createConnectedRouter(options);

  var FarceRouter = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(FarceRouter, _React$Component);

    var _super = _createSuper(FarceRouter);

    function FarceRouter(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.store = store || createFarceStore({
        historyProtocol: historyProtocol,
        historyMiddlewares: historyMiddlewares,
        historyOptions: historyOptions,
        routeConfig: routeConfig
      });
      return _this;
    }

    var _proto = FarceRouter.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.store.dispatch(FarceActions.dispose());
    };

    _proto.render = function render() {
      return /*#__PURE__*/React.createElement(Provider, {
        store: this.store
      }, /*#__PURE__*/React.createElement(ConnectedRouter, this.props));
    };

    return FarceRouter;
  }(React.Component);

  return FarceRouter;
}